import React from 'react'
import EmployeeLeavePlans from './EmployeeLeavePlans'

class ManageLeavePlans extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activePlans: {
        ...this.props.active_plans,
        currentPage: 1,
        options: [
                    {value: 'switch', label: 'Switch To this LeavePlan'},
                    {value: 'archive', label: 'Archive Leave Plan'},
                    {value: 'delete', label: 'Delete Leave Plan'},
                 ]
      },
      archivedPlans: {
        ...this.props.archived_plans,
        currentPage: 1,
        options: [
                    {value: 'reactivate', label: 'Reactivate Leave Plan'},
                    {value: 'delete', label: 'Delete Leave Plan'},
                 ]
      }
    }

  }

  renameLeavePlan (status, leave_plan_id, new_name) {
    let leavePlanKey = status == 'active' ? 'activePlans' : 'archivedPlans'
    let leavePlans = this.state[leavePlanKey]['leave_plans']
    let updatedLeavePlans = leavePlans.map((plan, index) => {
      plan['name'] = plan['id'] == leave_plan_id ? new_name : plan['name']
      return plan
    })

    this.setState({
      [leavePlanKey]: {
        ...this.state[leavePlanKey],
        leave_plans: updatedLeavePlans
      }
    });
  }

  switchLeavePlan (leave_plan_id) {
    $.displaySpinner('.loadSpinner')
    $.ajax({
      method: 'PATCH',
      url: `/leave_plans/${leave_plan_id}/switch_leave_plan`,
      success: (data) => {
        $.removeSpinner()
        if (data.status === 'success'){
          toastr.success('LeavePlan has been switched.')
          window.location = '/'
        }
        else {
          toastr.error(data.error_message, 'Error')
        }
      }
    })
  }

  archiveLeavePlan (status, leave_plan_id) {
    $.displaySpinner('.loadSpinner')
    $.ajax({
      method: 'PATCH',
      url: `/leave_plans/${leave_plan_id}/archive_leave_plan`,
      data:{
        active_page: this.state.activePlans.currentPage,
        archived_page: this.state.archivedPlans.currentPage
      },
      success: (data) => {
        $.removeSpinner()
        if (data.status === 'success') {
          toastr.success(data.message)
          this.resetLeavePlans(data['emp_leave_plans'])
        } else {
          toastr.error(data.error_message, 'Error')
        }
      }
    })
  }

  removeLeavePlan (status, leave_plan_id ) {
    $.displaySpinner('.loadSpinner')
    $.ajax({
      method: 'PATCH',
      url: `/leave_plans/${leave_plan_id}/delete_leave_plan`,
      data:{
        active_page: this.state.activePlans.currentPage,
        archived_page: this.state.archivedPlans.currentPage
      },
      success: (data) => {
        $.removeSpinner()
        if (data.status === 'success') {
          toastr.success(data.message)
          this.resetLeavePlans(data['emp_leave_plans'])
        } else {
          toastr.error(data.error_message, 'Error')
        }
      },
      error: (msg) => {
        $.removeSpinner()
        toastr.error(msg['responseJSON']['error_message'], 'Error')
      }
    })
  }

  reactivateLeavePlan (leave_plan_id) {
    $.displaySpinner('.loadSpinner')
    $.ajax({
      method: 'PATCH',
      url: `/leave_plans/${leave_plan_id}/reactivate_leave_plan`,
      data:{
        active_page: this.state.activePlans.currentPage,
        archived_page: this.state.archivedPlans.currentPage
      },
      success: (data) => {
        $.removeSpinner()
        if (data.status === 'success') {
          toastr.success(data.message)
          this.resetLeavePlans(data['emp_leave_plans'])
        } else {
          toastr.error(data.error_message, 'Error')
        }
      }
    })
  }

  resetLeavePlans (updated_leave_plans) {
    this.setState({
      activePlans: {
        ...this.state.activePlans,
        leave_plans: updated_leave_plans['active_plans']['leave_plans'],
        leave_plans_count: updated_leave_plans['active_plans']['leave_plans_count']
      },
      'archivedPlans': {
        ...this.state.archivedPlans,
        leave_plans: updated_leave_plans['archived_plans']['leave_plans'],
        leave_plans_count: updated_leave_plans['archived_plans']['leave_plans_count']
      }
    });
  }

  currentPageNumber (leave_status, selectedPageNumber) {
    let url = window.location.pathname
    url += window.location.search
    url = $.buildURL("leave_status", leave_status, url)

    let params = {
      active_page: leave_status == 'active' ? selectedPageNumber : this.state.activePlans.currentPage,
      archived_page: leave_status == 'archived' ? selectedPageNumber : this.state.archivedPlans.currentPage
    }

    let _this = this
    $.displaySpinner('.loadSpinner')
    $.ajax(({
      cache: false,
      url: url,
      dataType: 'json',
      data: params,
      success: (response) => {
        $.removeSpinner()
        if (response.leave_plans.leave_plans.length){
          let leavePlanKey = leave_status == 'active' ? 'activePlans' : 'archivedPlans'
          _this.setState({
            [leavePlanKey]: {
              ...this.state[leavePlanKey],
              leave_plans: response.leave_plans.leave_plans,
              leave_plans_count: response.leave_plans.leave_plans_count,
              currentPage: selectedPageNumber
            }
          });
        }
      }
    }))
  }

  render() {
    return (
      <div>
        <div className='loadSpinner'></div>
        <EmployeeLeavePlans
          type={'active'}
          leavePlans={this.state.activePlans}
          renameLeavePlan={this.renameLeavePlan.bind(this)}
          switchLeavePlan={this.switchLeavePlan.bind(this)}
          archiveLeavePlan={this.archiveLeavePlan.bind(this)}
          removeLeavePlan={this.removeLeavePlan.bind(this)}
          currentPageNumber={this.currentPageNumber.bind(this)}
        />
        <EmployeeLeavePlans
          type={'archived'}
          leavePlans={this.state.archivedPlans}
          renameLeavePlan={this.renameLeavePlan.bind(this)}
          reactivateLeavePlan={this.reactivateLeavePlan.bind(this)}
          removeLeavePlan={this.removeLeavePlan.bind(this)}
          currentPageNumber={this.currentPageNumber.bind(this)}
        />
      </div>
    )
  }
}

export default ManageLeavePlans;
